/* tslint:disable */
/* eslint-disable */
/**
 * pkg/api/event.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ApiPriorityClassResourceLimits,
    ApiPriorityClassResourceLimitsFromJSON,
    ApiPriorityClassResourceLimitsFromJSONTyped,
    ApiPriorityClassResourceLimitsToJSON,
} from './ApiPriorityClassResourceLimits';
import {
    QueuePermissions,
    QueuePermissionsFromJSON,
    QueuePermissionsFromJSONTyped,
    QueuePermissionsToJSON,
} from './QueuePermissions';

/**
 * 
 * @export
 * @interface ApiQueue
 */
export interface ApiQueue {
    /**
     * Determines whether scheduling is enabled for this queue.
     * @type {boolean}
     * @memberof ApiQueue
     */
    cordoned?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiQueue
     */
    groupOwners?: Array<string>;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ApiQueue
     */
    labels?: { [key: string]: string; };
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiQueue
     */
    labelsDeprecated?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ApiQueue
     */
    name?: string;
    /**
     * 
     * @type {Array<QueuePermissions>}
     * @memberof ApiQueue
     */
    permissions?: Array<QueuePermissions>;
    /**
     * 
     * @type {number}
     * @memberof ApiQueue
     */
    priorityFactor?: number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof ApiQueue
     */
    resourceLimits?: { [key: string]: number; };
    /**
     * Map from priority class name to resource limit overrides for this queue and priority class.
     * If provided for a priority class, global limits for that priority class do not apply to this queue.
     * @type {{ [key: string]: ApiPriorityClassResourceLimits; }}
     * @memberof ApiQueue
     */
    resourceLimitsByPriorityClassName?: { [key: string]: ApiPriorityClassResourceLimits; };
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiQueue
     */
    userOwners?: Array<string>;
}

export function ApiQueueFromJSON(json: any): ApiQueue {
    return ApiQueueFromJSONTyped(json, false);
}

export function ApiQueueFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiQueue {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'cordoned': !exists(json, 'cordoned') ? undefined : json['cordoned'],
        'groupOwners': !exists(json, 'groupOwners') ? undefined : json['groupOwners'],
        'labels': !exists(json, 'labels') ? undefined : json['labels'],
        'labelsDeprecated': !exists(json, 'labelsDeprecated') ? undefined : json['labelsDeprecated'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'permissions': !exists(json, 'permissions') ? undefined : ((json['permissions'] as Array<any>).map(QueuePermissionsFromJSON)),
        'priorityFactor': !exists(json, 'priorityFactor') ? undefined : json['priorityFactor'],
        'resourceLimits': !exists(json, 'resourceLimits') ? undefined : json['resourceLimits'],
        'resourceLimitsByPriorityClassName': !exists(json, 'resourceLimitsByPriorityClassName') ? undefined : (mapValues(json['resourceLimitsByPriorityClassName'], ApiPriorityClassResourceLimitsFromJSON)),
        'userOwners': !exists(json, 'userOwners') ? undefined : json['userOwners'],
    };
}

export function ApiQueueToJSON(value?: ApiQueue | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'cordoned': value.cordoned,
        'groupOwners': value.groupOwners,
        'labels': value.labels,
        'labelsDeprecated': value.labelsDeprecated,
        'name': value.name,
        'permissions': value.permissions === undefined ? undefined : ((value.permissions as Array<any>).map(QueuePermissionsToJSON)),
        'priorityFactor': value.priorityFactor,
        'resourceLimits': value.resourceLimits,
        'resourceLimitsByPriorityClassName': value.resourceLimitsByPriorityClassName === undefined ? undefined : (mapValues(value.resourceLimitsByPriorityClassName, ApiPriorityClassResourceLimitsToJSON)),
        'userOwners': value.userOwners,
    };
}

